module.exports = __webpack_public_path__ + "img/paypal.3007e49d.png";